import { apiReq } from "./_req";
import type { IGetHomeHub } from "@backend-ctrl/hub.controller";
import { QueryKey, useQuery } from "react-query";
import { CacheKeyTypes } from "../cache";
import { HUBS_STALETIME } from "../../constants";

async function getHomeHub() {
  const { data } = await apiReq.get<IGetHomeHub>(`/hub/home`);
  data.recent_library_updates = data.recent_library_updates.filter((library) => library.maps.length !== 0);
  return data;
}

export const useHomeHub = () => {
  const queryKey: QueryKey = CacheKeyTypes.HomeHub;
  const q = useQuery<IGetHomeHub, Error>(queryKey, () => getHomeHub(), {
    staleTime: HUBS_STALETIME,
    refetchOnWindowFocus: true,
  });

  return q;
};
